import React from 'react';
import { GroupEntity } from '../../../types';
import style from '../group.module.scss';
import CrossIcon from '../../../../../../../../../assets/svg/solo-chat/circle-cross-3.svg';
import { usePermissions } from '../../../../../hooks';

type Props = {
	entity: GroupEntity;
	value: string;	
	keyValue:string
	deleteEntity: (k:string,v:string) => void;
};

export function Entity(props: Props) {
	const canDelete = usePermissions('nlu.Delete')
	const { entity, value, keyValue, deleteEntity } = props;
	return (
		<>
				<div
			role="button"
			data-can-delete={canDelete}
			className={style.entity}
		>
					<span>{entity.name}</span>
					<span className={style.entityValue}>{value}</span>
					{/* </span> */}
					{canDelete && (
						<button onClick={() => deleteEntity(entity.id,keyValue)}>
							<img src={CrossIcon} alt="delete entity" />
						</button>
					)}
				</div>
	</>			
	);
}